export const PLANT_INFO = (t) => ({
  plantName: {
    key: "plantName",
    labelText: t("plantInformationStrings.plantName"),
  },
  plantLocation: {
    key: "plantLocation",
    labelText: t("plantInformationStrings.plantLocation"),
  },
  water_type: {
    key: "water_type",
    labelText: t("plantInformationStrings.waterType"),
  },
  num_trains: {
    key: "num_trains",
    labelText: t("plantInformationStrings.trainsNumber"),
  },
  tol_num_modules: {
    key: "tol_num_modules",
    labelText: t("plantInformationStrings.modulesNumber"),
  },
  tol_active_area: {
    key: "tol_active_area",
    labelText: t("plantInformationStrings.activeAreaNumber"),
  },
  dataset_name: {
    key: "dataset_name",
    labelText: t("plantInformationStrings.datasetName"),
  },
});
export const SELECTED_SECTION = (t) => ({
  sel_train: {
    labelText: t("addNewPlant.train"),
  },
  sel_rack: {
    labelText: t("addNewPlant.rack"),
  },
  sel_modules_per_rack: {
    labelText: t("addNewPlant.noOfModules"),
  },
  sel_active_area: {
    labelText: t("addNewPlant.noActiveAreaInvolved"),
  },
  sel_module_used: {
    labelText: t("plantInformationStrings.moduleType"),
  },
  is_dupont_element: {
    labelText: t("plantInformationStrings.is_dupont_element"),
  },
  sel_segment: {
    labelText: t("addNewPlant.dataSegmentation"),
  },
});
